// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ml-iv","content":"styles_content___fXee"};